module.exports = __webpack_public_path__ + "img/jpm_icons1.a6556829.svg";